// extracted by mini-css-extract-plugin
module.exports = {"AwardCard":"AwardCard-module--AwardCard--3I8zL","ImgContainer":"AwardCard-module--ImgContainer--f-Tjh"};